import type { FilterValues } from "@/lib/filters";
import { STATUS_SPEC, runEntityFrom } from "../scope";

export const RUNS_FILTERS_KEY = "pcogs.runs.filters.v1";
type Stored = { entity: string | null; status: string | null };
const STATUS_VALUES = new Set((STATUS_SPEC.options ?? []).map((option) => option.value));

export function readRunsFilters(): FilterValues | null {
  try {
    const raw = window.localStorage.getItem(RUNS_FILTERS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<Stored>;
    const entity = runEntityFrom(parsed.entity);
    const status = typeof parsed.status === "string" && STATUS_VALUES.has(parsed.status) ? parsed.status : null;
    if (entity === "all" && status === null) return null;
    return { entity: entity === "all" ? null : entity, status };
  } catch {
    return null;
  }
}

export function writeRunsFilters(values: FilterValues): void {
  try {
    const entity = runEntityFrom(values.entity);
    const status = typeof values.status === "string" && STATUS_VALUES.has(values.status) ? values.status : null;
    if (entity === "all" && status === null) window.localStorage.removeItem(RUNS_FILTERS_KEY);
    else window.localStorage.setItem(RUNS_FILTERS_KEY, JSON.stringify({ entity: entity === "all" ? null : entity, status } satisfies Stored));
  } catch {
    // Remembering is a convenience; private windows and blocked storage keep the URL defaults.
  }
}

export function hasFilterParams(search: Record<string, unknown>): boolean {
  return "f_entity" in search || "f_status" in search;
}
